'use client';

import React from 'react';
import { Icon } from '../components-internal/Icon';
import { getTabTarget } from '../helpers/tabTarget';
import ArrowRightIcon from '../icons/ArrowRightIcon';
import { pushDataLayer } from '../pushDataLayer';
import { ComponentRedirectTiles } from '$/(cms)/_modules/cmsService/types';
import { FeLink } from '$/components/FeLink';
// import './RedirectTiles.css';

const ICON_SIZE = 32;

export const RedirectTiles: React.FC<ComponentRedirectTiles> = ({
  items,
  tilesTitle,
}) => {
  return (
    <div className="redirectTiles mx-auto pt-8 lg:pt-10 xl:pt-12">
      <h3 className="mb-4  text-gray-900 alpha-display-2 md:mb-6 md:text-center lg:mb-7 xl:mb-8">
        {tilesTitle}
      </h3>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        {items?.map((option, index) => (
          <FeLink
            key={option?.itemTitle}
            target={getTabTarget(option?.link_target)}
            href={option?.link_url}
            className="flex flex-row rounded-lg p-3 shadow-md bg-white lg:p-4"
            onClick={(e) => {
              e.stopPropagation();
              pushDataLayer({
                event: 'navigate',
                component_type: 'tiles',
                component_title: `Category Entries_${option?.itemTitle}`,
                action: 'click',
                index: index,
              });
            }}
          >
            <div className="flex w-full items-center justify-between">
              <div className="flex h-full items-center justify-between xl:items-center">
                {option?.icon ? (
                  <i className="mr-2 flex items-center justify-center rounded-full p-1 bg-blue-light text-blue-dark lg:p-2">
                    <Icon
                      width={ICON_SIZE}
                      height={ICON_SIZE}
                      icon={option.icon}
                    />
                  </i>
                ) : null}
                {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
                <h3 className="redirect-tiles-item-title max-w-full text-gray-900 lg:max-w-3/4">
                  {option?.itemTitle}
                </h3>
              </div>
              <ArrowRightIcon className="size-shapes/icon-size-lg shrink-0" />
            </div>
          </FeLink>
        ))}
      </div>
    </div>
  );
};
